const apiUrl = "https://backend.gladiators.cz"

export {apiUrl}